export enum ImageGravity {
    Center = 'center',
    Topleft = 'top-left',
    Top = 'top',
    Topright = 'top-right',
    Left = 'left',
    Right = 'right',
    Bottomleft = 'bottom-left',
    Bottom = 'bottom',
    Bottomright = 'bottom-right',
}